import React, {useRef, useEffect, useState} from "react";
import loadable from "@loadable/component";
const AsyncSelect = loadable.lib(() => import("react-select/async"), { ssr: true });
import styles from "./style.css";
import PropTypes from "prop-types";

const OnlineSearch = ({
    onChange,
    getOptions,
    placeholder = "Select..",
    classNamePrefix = "search-select",
    autoFocus = false,
    focusAfterSelection = true,
    customDefaultValue = "",
    labelClass,
    label = "",
    onInputChangeCallback = () => {},
    overrideSearchRef,
    ...restProps
}) => {
    const [searchRef, setSearchRef] = useState(useRef());
    const [inputValue, setInputValue] = useState(customDefaultValue || "");
    const [placeholderValue, setPlaceHolderValue] = useState(placeholder);

    useEffect(() => {
        if (overrideSearchRef) {
            setSearchRef(overrideSearchRef);
        }
    }, [overrideSearchRef]);

    useEffect(() => {
        if (autoFocus) {
            searchRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [autoFocus]);

    const onInputChange = (v, action) => {
        if (action.action !== "input-blur" && action.action !== "menu-close") {
            setInputValue(v);
            onInputChangeCallback(v);
            if (v.length === 0) {
                setPlaceHolderValue(placeholder);
            }
        }
    };

    useEffect(() => {
        setInputValue(customDefaultValue || "");
    }, [customDefaultValue]);

    useEffect(() => {
        if (inputValue.length > 0 && focusAfterSelection) {
            searchRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputValue]);

    return (
        <React.Fragment >
            <AsyncSelect fallback={<React.Fragment />}>
                {({ default: AsyncSelectLoadable }) => (<AsyncSelectLoadable
                    key={!!inputValue.length}
                    inputValue={inputValue}
                    onInputChange={onInputChange}
                    ref={searchRef}
                    onChange={v => {
                        onChange(v, setInputValue);
                    }}
                    className="search-select-container"
                    placeholder={placeholderValue}
                    loadOptions={getOptions}
                    //removes the 'No Options' label even when there is no options loaded for a search
                    noOptionsMessage={() => null}
                    // options={options}
                    classNamePrefix={classNamePrefix}
                    {...restProps}
                />)}
            </AsyncSelect>
            <label className={labelClass} styleName={"styles.searchLabel"}>{label}</label>
        </React.Fragment>

    );
};

OnlineSearch.propTypes = {
    data: PropTypes.array,
    defaultMenuIsOpen: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    getOptions: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    customDefaultValue: PropTypes.string,
    autoFocus: PropTypes.bool,
    classNamePrefix: PropTypes.string,
    labelClass: PropTypes.string,
    label: PropTypes.string,
    focusAfterSelection: PropTypes.bool,
    onInputChangeCallback: PropTypes.func,
    overrideSearchRef: PropTypes.func
};

export default OnlineSearch;
